<template>
    <li>
        <div class="grid grid-cols-[30px_3fr_1fr_1fr] gap-4 py-2.5 h-16">
            <span class="flex items-center">
                <svg-vue
                    v-if="invite.user"
                    icon="circle-check-solid"
                    class="fill-salesium-green w-6 h-6"
                />
            </span>
            <span class="flex items-center">{{ invite.email }}</span>
            <span class="justify-self-start flex items-center">{{
                invite.to_display_name
            }}</span>
            <span class="justify-self-end">
                <span v-if="invite.user"
                    ><span class="w-24 h-11 flex items-center"
                        >Existing User</span
                    ></span
                >
                <span v-else-if="invite.status === 1"
                    ><Button
                        class="w-24 h-11 bg-salesium-grey-100 text-white rounded-lg"
                        >Pending</Button
                    ></span
                >
                <span v-else
                    ><button
                        class="w-24 h-11 bg-salesium-blue text-white rounded-lg"
                        @click="inviteUser"
                    >
                        Invite User
                    </button></span
                >
            </span>
        </div>
        <hr />
    </li>
</template>
<script>
export default {
    data() {
        return {};
    },
    props: ["invite"],
    methods: {
        async inviteUser() {
            const response = await window.axios.post(
                `/api/invitation/${this.invite.id}/sendInvite`
            );
            this.$emit("new-data");
        },
    },
};
</script>
